export default __webpack_public_path__ + "static/media/searchIcon.c31c5dcd.svg";